import { joinURLPath } from '@sigma-frontend-libs/commons'
import { TaskStates } from '@sigmasms/shared-types'

import { globalErrorHandler, request } from '@/utils'

import render from './render'

export default {
  name: 'TasksFrequency',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      loading: false
    }
  },

  methods: {
    async changeFrequency(id, frequency) {
      try {
        this.loading = true
        const data = await request.update(joinURLPath('tasks', id), {
          body: {
            state: TaskStates.paused,
            data: {
              amount: this.value.data.amount,
              frequency
            }
          }
        })
        if (data && data.frequency === frequency) {
          this.addSnackbar({
            text: this.getTranslate('tasks.snackbars.updated'),
            type: 'success'
          })
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    }
  },

  render
}
